import { Paragraph } from "@smartsuite/react-ui/lib";

interface TextAcceleratorProps {
  maxLength?: number;
  length: number;
}

export const TextAccelerator = ({
  maxLength,
  length,
}: TextAcceleratorProps): JSX.Element | null => {
  const acceleratorText = maxLength ? `${length} of ${maxLength}` : "";

  if (!acceleratorText) return null;

  return (
    <Paragraph size="xs" color="currentColor" className="text-area-field-control--accelerator">
      {acceleratorText}
    </Paragraph>
  );
};
